import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

let API_URL = 'https://my.simplerun.ru/api/v1';

const headers = {
	'Content-Type': 'application/json',
	'app-token': 'secret'
};

const instance = axios.create({
	headers,
});
const notifyAboutError = () => {
	// empty
};

instance.interceptors.response.use(
	response => response,
	(error) => {
		notifyAboutError(error);
		return Promise.reject(error);
	},
);

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		step: 0,
		validation: null,
		token: null,
		validation_error: null,
		version: {},
		values: JSON.parse(localStorage.getItem('qwiz-sr')) || [],
		steps: [],
	},
	actions: {
		skipStep ({ commit }) {
			commit('skip_step')
		},
		setStep ({ commit }, step) {
			commit('set_step', step)
		},
		setStepBack({ commit }) {
			commit('step_back')
		},
		setToken ({ commit }, token) {
			commit('set_token', token)
		},
		setValue ({ commit, state }, stepData) {
			let index = state.values.findIndex(v => v.id == stepData.id);
			if (index !== -1) {
				commit('clear_value', index)
			}
			commit('set_value', stepData)
		},
		async getVersion ({ commit }) {
			try {
				const version = await instance.get(`${API_URL}/check-version`, { headers: headers })
				commit('set_version', version.data);
			} finally {
				console.log('error')
			}
		},
		async checkUser ({ commit }, userData) {
			commit('set_validation_error', null);
			commit('set_validation', null);
			try {
				const validation = await instance.post(`${API_URL}/register/validate`, userData, { headers: headers })
				commit('set_validation', validation.data);
			} catch(error) {
				commit('set_validation_error', error.response.data);
			}
		},
		async registerUser ({ commit }, userData) {
			commit('set_validation_error', null);
			try {
				const user = await instance.post(`${API_URL}/register`, userData, { headers: headers })
				commit('set_token', user.data.api_token);
			} catch(error) {
				commit('set_validation_error', error.response.data);
			}
		},
		async sendQuiz ({ state }, quizData) {
			try {
				await instance.post(`${API_URL}/personal/quiz`, quizData, { headers: {
					'Content-Type': 'application/json',
					'app-token': 'secret',
					'Authorization': `Bearer ${state.token}`
				} })
			} catch(error) {
				console.log(error);
			}
		}
	},
	mutations: {
		skip_step (state) {
			state.step++
		},
		step_back (state) {
			state.steps.splice(-1,1)
			let lastStep = state.steps.pop();
			state.step = parseFloat(lastStep)
		},
		set_step (state, step) {
			state.step = step
			let index = state.steps.includes(parseFloat(step));
			if (!index) {
				state.steps.push(parseFloat(step))
			}
		},
		set_value (state, stepData) {
			state.values.push(stepData);

			if (localStorage.getItem('qwiz-sr')) {
				const qwizSr = JSON.parse(localStorage.getItem('qwiz-sr'));
				qwizSr.push(stepData);
				localStorage.setItem('qwiz-sr', JSON.stringify(qwizSr));
			} else {
				const qwizSr = []
				qwizSr.push(stepData)
				localStorage.setItem('qwiz-sr', JSON.stringify(qwizSr))
			}
		},
		clear_value (state, index) {
			state.values.splice(index, 1);

			const qwizSr = JSON.parse(localStorage.getItem('qwiz-sr'));
			qwizSr.splice(index, 1);
			localStorage.setItem('qwiz-sr', JSON.stringify(qwizSr));
		},
		set_version (state, version) {
			state.version = version;
		},
		set_validation (state, validation) {
			state.validation = validation;
		},
		set_validation_error (state, error) {
			state.validation_error = error;
		},
		set_token (state, token) {
			state.token = token;
		},
	}
})

export default store;